module.exports = __webpack_public_path__ + "media/application/images/icons/green-finger-print-e3901a93046ab9c987c1f6fe932903cc.svg";